import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import styles from './BackButton.module.css';

export default function BackButton() {
  const navigate = useNavigate();
  const location = useLocation();
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true);
  }, []);

  if (location.pathname === '/') return null;

  // Don't show on login/register pages
  const hiddenRoutes = ['/login', '/register', '/forgot-password', '/verify-email'];
  const isHidden = hiddenRoutes.includes(location.pathname);

  if (isHidden) return null;

  return (
    <button
      className={`${styles.backButton} ${animate ? styles.animateIn : ''}`}
      onClick={() => navigate(-1)}
      aria-label="Go back"
    >
      <FaArrowLeft className={styles.icon} />
    </button>
  );
}
